// extracted by mini-css-extract-plugin
export default {"progressTitle":"circleProgressBar_progressTitle__NPXQm"};